export default __webpack_public_path__ + "static/media/home_box.4be44a33.jpg";